import styled from 'styled-components';

const StyledCardContainer = styled.div`
  background-color: rgba(255, 255, 255, 0.1);
  padding: 70px 30px 44px;
  border-radius: 10px;
  width: 100%;
  margin: 0 20px;
  background: rgba(0, 0, 0, 0.17);
  backdrop-filter: blur(10px);
  opacity: 0;
  transform: scale(0.8); /* 初始縮小效果 */
  animation: pop-in 1s ease forwards; /* 小螢幕使用由內而外彈出動畫 */

  @media (min-width: 448px) {
    margin: 0;
    width: 70%;
    min-width: 400px;
  }

  @media (min-width: 628px) {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    padding: 0 44px;
    width: 50%;
    max-width: 500px;
    min-width: auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 0;
    animation: slide-in 1s ease forwards; /* 大螢幕維持滑入效果 */
  }

  h2 {
    font-size: 36px;
    font-weight: 400;
    margin: 0 0 12px;
    color: white;
  }

  h3 {
    color: rgba(255, 255, 255, 0.38);
    margin: 0 0 48px;
    font-weight: 400;
    font-size: 16px;
  }

  /* 小螢幕的由內而外彈出效果 */
  @keyframes pop-in {
    0% {
      opacity: 0;
      transform: scale(0.8); /* 縮小 */
    }
    60% {
      opacity: 1;
      transform: scale(1.05); /* 稍微放大超過正常尺寸 */
    }
    100% {
      opacity: 1;
      transform: scale(1); /* 回到正常尺寸 */
    }
  }

  /* 大螢幕的滑入效果 */
  @keyframes slide-in {
    0% {
      opacity: 0;
      transform: translateX(100%);
    }
    100% {
      opacity: 1;
      transform: translateX(0);
    }
  }
`;

export default StyledCardContainer;
